export class DisStartingModel
{
  discode = '' ;
  disname = '' ;
  compcode = '1' ;
  userid = 'sa' ;
  modifieddate = '2022-01-01' ;
}
